/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // //Update Version here to force refresh
  let VERSION = '1.9.4';
  // console.log('app ver: ' + VERSION);
  // console.log('system ver: ' + localStorage.getItem('_ovvyappver'));
  // if(localStorage.getItem('_ovvyappver') != VERSION) {
  //   localStorage.setItem('_ovvyappver', VERSION);
  //   window.location.reload(true);
  // }

  register(`${process.env.BASE_URL}service-worker.js?${VERSION}`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      });
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      // window.location.reload(true)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
